import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { Reveal, SectionLabel } from "./primitives";
import { businessDetails } from "../data/content";
import { track } from "../lib/analytics";

export const ContactSection = () => (
  <section
    id="contact"
    aria-labelledby="contact-heading"
    className="border-t border-brand-border bg-white py-16 lg:py-24"
  >
    <div className="mx-auto max-w-content px-4 lg:px-8">
      <Reveal className="max-w-2xl">
        <SectionLabel>Contact us</SectionLabel>
        <h2
          id="contact-heading"
          className="mt-3 font-heading text-3xl font-bold tracking-tight text-brand-navy lg:text-4xl"
        >
          Contact Freeman Jones
        </h2>
        <p className="mt-3 text-lg leading-relaxed text-brand-body">
          Our customer support team is here to help with questions about your Freeman Jones
          arrangement.
        </p>
      </Reveal>

      <Reveal delay={0.1} className="mt-10 grid gap-4 md:grid-cols-3">
        <a
          href={businessDetails.phoneLink}
          onClick={() => track("phone_number_clicked", { location: "contact" })}
          className="flex items-start gap-4 rounded-2xl border border-brand-border bg-brand-bg p-6 transition-colors hover:border-brand-teal"
          data-testid="contact-card-phone"
        >
          <Phone className="mt-1 h-6 w-6 flex-shrink-0 text-brand-teal" aria-hidden="true" />
          <span>
            <span className="block text-sm font-semibold uppercase tracking-wide text-brand-teal">Telephone</span>
            <span className="block font-heading text-xl font-bold text-brand-navy">{businessDetails.phoneDisplay}</span>
          </span>
        </a>

        <a
          href={businessDetails.emailLink}
          onClick={() => track("email_address_clicked", { location: "contact" })}
          className="flex items-start gap-4 rounded-2xl border border-brand-border bg-brand-bg p-6 transition-colors hover:border-brand-teal"
          data-testid="contact-card-email"
        >
          <Mail className="mt-1 h-6 w-6 flex-shrink-0 text-brand-teal" aria-hidden="true" />
          <span className="min-w-0">
            <span className="block text-sm font-semibold uppercase tracking-wide text-brand-teal">Email</span>
            <span className="block whitespace-nowrap font-heading text-base font-bold text-brand-navy sm:text-lg">{businessDetails.email}</span>
          </span>
        </a>

        <div className="flex items-start gap-4 rounded-2xl border border-brand-border bg-brand-bg p-6" data-testid="contact-card-address">
          <MapPin className="mt-1 h-6 w-6 flex-shrink-0 text-brand-teal" aria-hidden="true" />
          <span>
            <span className="block text-sm font-semibold uppercase tracking-wide text-brand-teal">Postal address</span>
            <span className="block font-heading text-lg font-bold leading-snug text-brand-navy">{businessDetails.registeredOffice}</span>
          </span>
        </div>
      </Reveal>
    </div>
  </section>
);
